import { propertyValue } from './dood-block-config';
import { doodModalConfig } from './dood-modal-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ZEROSIXLINKACCOUNTMODAL_LEGACY_FIELD_ORDER = [
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  zerosixLinkAccountModalDescriptor: _generatedZerosixLinkAccountModalDescriptor,
  zerosixLinkAccountModalModalDefinition,
  zerosixLinkAccountModalDashboardLayout,
  zerosixLinkAccountModalConfig,
  zerosixLinkAccountModalResolveConfig,
  zerosixLinkAccountModalProperties,
} = doodModalConfig(
  {
    name: "Zerosix - Link account modal",
    handle: "zerosix-link-account-modal",
    internal_name: "ZerosixLinkAccountModal",
    componentType: 'ZerosixLinkAccountModalComponent',
    category: 'modal',
    description: "Zerosix - Link account modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "zerosix-link-account-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function zerosixLinkAccountModalDescriptor(): IBlockDescriptor;
export function zerosixLinkAccountModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function zerosixLinkAccountModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedZerosixLinkAccountModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedZerosixLinkAccountModalDescriptor, zerosixLinkAccountModalProperties, fieldOrder);
}

export {
  zerosixLinkAccountModalModalDefinition,
  zerosixLinkAccountModalDashboardLayout,
  zerosixLinkAccountModalProperties,
  zerosixLinkAccountModalConfig,
  zerosixLinkAccountModalResolveConfig,
};

export type ZerosixLinkAccountModalConfig = typeof zerosixLinkAccountModalConfig;
